/* eslint-disable */
/* prettier-ignore */
import * as utils from '../utils'

export default {
  prefix: 'cus',
  iconName: 'clipboard',
  icon: [
    480, // width
    480, // height
    [],
    null,
    `
      M368,80h-48V56c0-4.418-3.582-8-8-8h-48V8c0-4.418-3.582-8-8-8h-96c-4.418,0-8,3.582-8,8v40h-48c-4.418,0-8,3.582-8,8v24
			H48c-4.418,0-8,3.582-8,8v384c0,4.418,3.582,8,8,8h320c4.418,0,8-3.582,8-8V88C376,83.582,372.418,80,368,80z M168,16h80v32h-80
			V16z M112,64h192v64H112V64z M104,144h208c4.418,0,8-3.582,8-8v-8h8v304H88V128h8v8C96,140.418,99.582,144,104,144z M360,464H56
      V96h40v16H80c-4.418,0-8,3.582-8,8v320c0,4.418,3.582,8,8,8h256c4.418,0,8-3.582,8-8V120c0-4.418-3.582-8-8-8h-16V96h40V464
      
      M136,176h-24c-4.418,0-8,3.582-8,8s3.582,8,8,8h24c4.418,0,8-3.582,8-8S140.418,176,136,176

      M240,176h-72c-4.418,0-8,3.582-8,8s3.582,8,8,8h72c4.418,0,8-3.582,8-8S244.418,176,240,176

      M304,160h-32c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h32c4.418,0,8-3.582,8-8v-32C312,163.582,308.418,160,304,160z
       M296,192h-16v-16h16V192
       
      M136,240h-24c-4.418,0-8,3.582-8,8s3.582,8,8,8h24c4.418,0,8-3.582,8-8S140.418,240,136,240

      M240,240h-72c-4.418,0-8,3.582-8,8s3.582,8,8,8h72c4.418,0,8-3.582,8-8S244.418,240,240,240

      M304,224h-32c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h32c4.418,0,8-3.582,8-8v-32C312,227.582,308.418,224,304,224z
       M296,256h-16v-16h16V256
       
      M136,304h-24c-4.418,0-8,3.582-8,8s3.582,8,8,8h24c4.418,0,8-3.582,8-8S140.418,304,136,304

      M240,304h-72c-4.418,0-8,3.582-8,8s3.582,8,8,8h72c4.418,0,8-3.582,8-8S244.418,304,240,304

      M304,288h-32c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h32c4.418,0,8-3.582,8-8v-32C312,291.582,308.418,288,304,288z
       M296,320h-16v-16h16V320
       
      M136,368h-24c-4.418,0-8,3.582-8,8s3.582,8,8,8h24c4.418,0,8-3.582,8-8S140.418,368,136,368

      M240,368h-72c-4.418,0-8,3.582-8,8s3.582,8,8,8h72c4.418,0,8-3.582,8-8S244.418,368,240,368

      M304,352h-32c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h32c4.418,0,8-3.582,8-8v-32C312,355.582,308.418,352,304,352z
       M296,384h-16v-16h16V384
       
      M432,240h-8v-16c0-4.418-3.582-8-8-8s-8,3.582-8,8v16h-8c-4.418,0-8,3.582-8,8v224c0,4.418,3.582,8,8,8h32
			c4.418,0,8-3.582,8-8V248C440,243.582,436.418,240,432,240z M424,464h-16V304h16V464z M424,288h-16v-32h16V288
      
      z
    ` // svg path data
  ]
}



// WEBPACK FOOTER //
// ./src/components/icon/custom-icons/custom-icons/clipboard.js